export default {
  form: {
    first_name: {
      label: 'Prenume',
    },
    last_name: {
      label: 'Nume de familie',
    },
    email: {
      label: 'E-mail',
    },
    phone_number: {
      label: 'Număr de telefon',
    },
    birthday: {
      label: 'Dată naștere',
    },
    city: {
      label: 'Oraș',
    },
  },
  buttons: {
    save: 'Salvează',
  },
  toasts: {
    success: 'Profil actualizat cu succes',
    error: 'Actualizarea profilului a eșuat',
  },
};
